export const server = "https://opentdb.com";
export const URL = {
  categoryURL: `${server}/api_category.php`,
  triviasURL: `${server}/api.php?`
};
